import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { ReportRequerimentoRenovacaoPjRequest, ReportRequerimentoRenovacaoPjResponse, ReportJobCreatedResponse, ReportJobStatusResponse } from './requerimento-renovacao-pj.model';

/** Cliente HTTP do relatório assíncrono Requerimento de Renovação de Certificado de Inscrição PJ. */
@Injectable({ providedIn: 'root' })
export class RequerimentoRenovacaoPjService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.prestador.reports.requerimentoRenovacaoPj;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    exportarPdf(request: ReportRequerimentoRenovacaoPjRequest): Observable<HttpResponse<ReportRequerimentoRenovacaoPjResponse | ReportJobCreatedResponse>> {
        return this.http.post<ReportRequerimentoRenovacaoPjResponse | ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf`, request, { observe: 'response' });
    }

    iniciarGeracaoAssincrona(request: ReportRequerimentoRenovacaoPjRequest): Observable<ReportJobCreatedResponse> {
        return this.http.post<ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf-async`, request);
    }

    consultarStatus(jobId: string): Observable<ReportJobStatusResponse> {
        return this.http.get<ReportJobStatusResponse>(`${this.PATH}/job/${jobId}/status`);
    }

    baixarPdf(jobId: string): Observable<ArrayBuffer> {
        return this.http.get(`${this.PATH}/job/${jobId}/download`, { responseType: 'arraybuffer' });
    }
}
